import { render } from "./Cube.vue?vue&type=template&id=23ab6aad&scoped=true"
import script from "./Cube.vue?vue&type=script&lang=js"
export * from "./Cube.vue?vue&type=script&lang=js"

import "./Cube.vue?vue&type=style&index=0&id=23ab6aad&scoped=true&lang=css"

import exportComponent from "/builds/tapetum1/tapetum-landing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23ab6aad"]])

export default __exports__